export const parseDecimalString = (
  value: string | null | undefined,
): number | null => {
  if (value === null) {
    return null;
  }
  const number = Number(value);
  if (isNaN(number)) {
    return null;
  }
  return number;
};
